<template>
  <div class="relative">
    <saving-overlay
      opacity="40"
      v-if="paymentPending || !stripe"
    ></saving-overlay>
    <div class="p-5">
      <div
        v-if="savedCard"
        class="mb-4 p-2 justify-center"
        style="border: 1px solid rgba(253, 202, 0, 0.7)"
      >
        <div>
          <div class="flex p-2 justify-between items-center">
            <span
              >{{ savedCard.brand.toUpperCase() }} **** **** ****
              {{ savedCard.last4 }}</span
            >
            <span
              >{{ savedCard.exp_month }}/{{ savedCard.exp_year % 100 }}</span
            >
          </div>
        </div>
        <div class="pt-2 flex justify-between">
          <span></span>
          <ranch-button
            v-show="!paymentPending"
            type="button"
            @click="payWithSavedCard"
            :label="i18n.payment.stripe.reuse_card"
            :icon="false"
          ></ranch-button>

          <button
            class="m-1 button warning border border-red-300 button-base"
            icon="trash-alt"
            :labell="i18n.payment.stripe.forget_card"
            @click="deletePaymentMethod"
          >
            <font-awesome-icon icon="trash-alt" fixed-width />
          </button>
        </div>
      </div>
      <h4 class="font-bold text-left text-xl mb-4" v-if="savedCard">
        {{ i18n.payment.stripe.use_other_card }}
      </h4>
      <div class="">
        <form @submit.prevent="payWithNewCard">
          <div
            id="card-element"
            ref="card"
            class="w-full py-2 pl-2 bg-full-white rounded border border-action"
            style="border: 1px solid rgba(253, 202, 0, 0.7)"
          ></div>
          <label class="block pb-3" v-if="config.save_payment_method">
            <simple-checkbox
              :label="i18n.payment.stripe.save_card"
              v-model="saveCard"
              name="saveCard"
            ></simple-checkbox>
          </label>
          <div class="pt-5 flex justify-center">
            <ranch-button
              id="card-button"
              :class="{ disabled: paymentPending }"
              v-show="!paymentPending"
              :label="i18n.payment.stripe.pay_button"
              :icon="['fas', 'credit-card']"
            />
          </div>
        </form>
      </div>
      <span class="help danger" v-if="stripeError" v-text="stripeError"></span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js/pure";

import SimpleCheckbox from "../../Design/Forms/SimpleCheckbox";

export default {
  props: ["config", "i18n", "savedPaymentMethod"],
  components: { SimpleCheckbox },
  data() {
    return {
      stripeError: null,
      stripe: null,
      cardElement: null,
      paymentPending: false,
      saveCard: this.config.save_payment_method,
    };
  },
  methods: {
    setUpStripe(stripe) {
      this.stripe = stripe;

      const options = {
        hidePostalCode: true,
        style: {
          base: {
            fontSize: "1rem",
            fontFamily: '"Lato", sans-serif',
          },
          invalid: {
            color: "#a94442",
            iconColor: "#a94442",
          },
        },
      };
      if (window.innerWidth <= 640) {
        options.style.base.fontSize = "15px";
      }
      let elements = stripe.elements({ locale: this.locale });

      this.cardElement = elements.create("card", options);
      this.cardElement.mount(this.$refs.card);
    },
    payWithNewCard() {
      this.payWithCard({
        payment_method: {
          card: this.cardElement,
        },
        setup_future_usage: this.saveCard ? "off_session" : null,
      });
    },
    payWithSavedCard() {
      this.payWithCard({
        payment_method: this.savedCardID,
      });
    },
    payWithCard(cardData) {
      if (this.paymentPending) {
        return;
      }
      this.stripeError = null;
      this.paymentPending = true;

      let statusUrl;
      return axios
        .post(this.config.createPaymentIntent)
        .then(({ data }) => {
          statusUrl = data.status_url;
          return data.client_secret;
        })
        .then((client_secret) => {
          return this.stripe.confirmCardPayment(client_secret, cardData);
        })
        .then((result) => {
          if (result.error) {
            throw result.error;
          }
          // The payment has succeeded. Refresh the status of the invoice
          return axios.get(statusUrl);
        })
        .then(() => {
          this.$emit("payment-success", "stripe");
        })
        .catch((error) => {
          let message = this.i18n.payment.unknownError;
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message = error.response.data.message;
          } else if (error.message) {
            message = error.message;
          }
          this.$emit("submitError");
          this.stripeError = message;
          this.paymentPending = false;
        });
    },
    reset() {
      this.stripeError = null;
    },
    deletePaymentMethod() {
      if (!confirm(this.i18n.payment.stripe.confirm_forget_card)) {
        return;
      }
      axios.delete("/api/app/billing/payment-method").then(() => {
        this.$emit("reload-payment-data");
      });
    },
  },
  computed: {
    savedCard() {
      if (
        !this.savedPaymentMethod ||
        this.savedPaymentMethod.gateway != "stripe" ||
        !this.savedPaymentMethod.payment_method ||
        !this.savedPaymentMethod.payment_method.card
      ) {
        return null;
      }
      return this.savedPaymentMethod.payment_method.card;
    },
    savedCardID() {
      if (!this.savedCard) {
        return null;
      }
      return this.savedPaymentMethod.payment_method.id;
    },
    locale() {
      return this.$route.params.locale;
    },
  },
  mounted() {
    loadStripe(this.config.key).then(this.setUpStripe);
  },
};
</script>
